/* eslint-disable import/prefer-default-export */
export const pageWidth = '1280px';
